'use strict';
import * as $j_app$002eprelude$002e$002dApp$002dCurrency from "./app.prelude.-App-Currency.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_prelude_AppCurrencies$() {
  this.aXI = null;
  this.aXJ = null;
  this.FH = null;
  $n_Lapp_prelude_AppCurrencies$ = this;
  this.aXI = $j_app$002eprelude$002e$002dApp$002dCurrency.$m_Lapp_prelude_AppCurrency$namedEnum$().wy();
  this.aXJ = $j_app$002eprelude$002e$002dApp$002dCurrency.$s_Lapp_prelude_AppCurrency$__USD__Lapp_prelude_AppCurrency();
  this.FH = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsquants_market_MoneyContext($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsquants_market_USD$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Set$().f8(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_Iterator$$anon$9(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$(), this.aXI.r()), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$2) => _$2.av0())))), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Seq$().ah(), true);
}
export { $c_Lapp_prelude_AppCurrencies$ as $c_Lapp_prelude_AppCurrencies$ };
$p = $c_Lapp_prelude_AppCurrencies$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_prelude_AppCurrencies$;
/** @constructor */
function $h_Lapp_prelude_AppCurrencies$() {
}
export { $h_Lapp_prelude_AppCurrencies$ as $h_Lapp_prelude_AppCurrencies$ };
$h_Lapp_prelude_AppCurrencies$.prototype = $p;
var $d_Lapp_prelude_AppCurrencies$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_prelude_AppCurrencies$, "app.prelude.AppCurrencies$", ({
  I9: 1
}));
export { $d_Lapp_prelude_AppCurrencies$ as $d_Lapp_prelude_AppCurrencies$ };
var $n_Lapp_prelude_AppCurrencies$;
function $m_Lapp_prelude_AppCurrencies$() {
  if ((!$n_Lapp_prelude_AppCurrencies$)) {
    $n_Lapp_prelude_AppCurrencies$ = new $c_Lapp_prelude_AppCurrencies$();
  }
  return $n_Lapp_prelude_AppCurrencies$;
}
export { $m_Lapp_prelude_AppCurrencies$ as $m_Lapp_prelude_AppCurrencies$ };
//# sourceMappingURL=app.prelude.-App-Currencies$.js.map
